import { AppService } from './../../../../../../core/app.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Input } from '../../../../../../components/forms/input/input';
import { LoaderComponent } from '../../../../../../components/ui/loader/loader.component';
import { ModePassationMarcheRes } from '../../../../../../data/http/responses/modepassationmarche.res';
import { ModePassationMarcheService } from '../../../../../../services/modepassation.service';
import { TypeModePassationMarcheService } from '../../../../../../services/typepassation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime } from 'rxjs';
import { toCamelCase, toSnakeCaseUpper } from '../../../../../../utils/helpers';
import { ModePassationMarcheReq, ModePassationMarcheSubRequest } from '../../../../../../data/http/requests/modepassationmarche.req';
import { routeAlias } from '../../../../../../../routesalias';
import { UiButtonComponent } from '../../../../../../components/button/button.component';
import { RouterLink } from '@angular/router';
import { SelectComponent } from '../../../../../../components/forms/select/select.component';

@Component({
  selector: 'app-edit',
  imports: [Input, ReactiveFormsModule, LoaderComponent, UiButtonComponent, SelectComponent, RouterLink],
  templateUrl: './edit.component.html',
  styleUrl: './edit.component.css'
})
export class EditModePassationMarchePage implements OnInit {
  public routeAlias = routeAlias;
  modePassationMarcheForm!: FormGroup;
  public modePassationMarchesData: ModePassationMarcheRes[] = []
  public modePassationMarchesId: string | null = ""
  public isLoading: boolean = false;
  public totalDelais: number = 0;
  public typeModePassations: any[] = []

  constructor(
    private fb: FormBuilder,
    private AppService: AppService,
    private modePassationMarcheService: ModePassationMarcheService,
    private typeModePassationService: TypeModePassationMarcheService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.modePassationMarcheForm = this.fb.group({
      typeModePassationMarche: ['', Validators.required],
      modePassationMarche: ['', Validators.required],
      mode: ['', Validators.required],
      delaiPublication: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      seuil: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      montage: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      lancement: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      ouverture: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      evaluation: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      negociationGreGre: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      organeControle: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      verificationDisponibiliteCredits: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      notificationResultats: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      delaiAttenteElaborationContrat: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      examenJuridiqueProjetContratCJC: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      signatureContratTitulaire: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      visaContratJuriste: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      visaContratDM: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      visaContratDFC: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      visaContratDCGIS: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      visaContratDGA: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      signatureContratDG: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      notificationContratTitulaireSC: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      delaiDelivranceOS: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      applicationId: this.AppService.getAppId()!,
    });
  }

  ngOnInit(): void {
    this.modePassationMarchesId = this.route.snapshot.paramMap.get('id');
    this.loadTypeModePassation()
    if (this.modePassationMarchesId) {
      this.loadModePassationMarcheById(this.modePassationMarchesId);
    } else {
      console.error('Aucun ID d\'activité trouvé dans l\'URL.');
    }
    this.modePassationMarcheForm.valueChanges.pipe(
      debounceTime(300) // Optionnel: pour éviter des calculs trop fréquents lors de la saisie rapide
    ).subscribe(() => {
      this.calculateTotalDelais();
    });
  }

  editModePassationMarche(): void {
    if (this.modePassationMarcheForm.valid) {
      this.isLoading = true
      //const mode = transformString(this.modePassationMarcheForm.value.modePassationMarche)
      // Liste des champs à exclure du tableau details
      const excludedFields = ['modePassationMarche', 'applicationId', 'mode', 'typeModePassationMarche'];

      // Création du tableau details
      const details: ModePassationMarcheSubRequest[] = [];

      // Parcourir tous les champs du formulaire
      Object.keys(this.modePassationMarcheForm.value).forEach(key => {
        // Exclure les champs spécifiés
        if (!excludedFields.includes(key)) {
          details.push({
            code: toSnakeCaseUpper(key),
            valeur: parseInt(this.modePassationMarcheForm.value[key], 10)
          });
        }
      });
      let requestBody: ModePassationMarcheReq = {
        applicationId: this.modePassationMarcheForm.value.applicationId,
        code: this.modePassationMarcheForm.value.mode,
        libelle: this.modePassationMarcheForm.value.modePassationMarche,
        type: this.modePassationMarcheForm.value.typeModePassationMarche,
        details: details,
        valeur: this.totalDelais
      }
      //console.log(requestBody)
      //return;
      this.modePassationMarcheService.update(this.modePassationMarchesId!, requestBody).subscribe({
        next: () => {
          this.isLoading = false;
          this.router.navigate([
            routeAlias.parameters.home,
            routeAlias.parameters.marches.home,
            routeAlias.parameters.marches.mode_passation_marches.home
          ]);
        },
        error: (error) => {
          console.error('Erreur lors de la mise à jour de la ligne budgétaire :', error);
          this.isLoading = false;
        }
      });
    }
  }

  loadModePassationMarcheById(id: string): void {
    this.modePassationMarcheService.getById(id).subscribe({
      next: (response: any) => {
        //console.log("Données reçues pour l'édition :", response.data)
        this.modePassationMarchesData = response.data; // Stockez la réponse complète si nécessaire

        const patchValue: { [key: string]: any } = {
          typeModePassationMarche: response.data.type, // Map le 'type' de l'API au champ du formulaire
          modePassationMarche: response.data.libelle,
          mode: response.data.code, // Map le 'code' de l'API au champ 'mode' du formulaire
          applicationId: this.AppService.getAppId()!,
        };

        // Mapper les champs du tableau 'details'
        response.data.details.forEach((detail: any) => {
          // Normaliser le code pour qu'il corresponde aux noms des formControls
          const formControlName = toCamelCase(detail.code);
          //console.log(formControlName)
          if (this.modePassationMarcheForm.contains(formControlName)) {
            patchValue[formControlName] = detail.valeur;
          }
        });

        // Appliquer les valeurs au formulaire
        this.modePassationMarcheForm.patchValue(patchValue);

        this.calculateTotalDelais(); // Recalculer le total après le chargement des données
      },
      error: (error) => {
        console.error('Erreur lors du chargement de l\'activité par ID :', error);
      }
    })
  }

  calculateTotalDelais(): void {
    let sum = 0;
    const formValues = this.modePassationMarcheForm.value;

    // Liste des champs numériques à additionner (assurez-vous qu'ils correspondent aux formControlName)
    const numericFields = [
      'delaiPublication', 'delaiPublicationSecond', 'montage',
      'lancement', 'ouverture', 'evaluation', 'negociationGreGre',
      'organeControle', 'verificationDisponibiliteCredits', 'notificationResultats',
      'delaiAttenteElaborationContrat', 'examenJuridiqueProjetContratCJC',
      'signatureContratTitulaire', 'visaContratJuriste', 'visaContratDM',
      'visaContratDFC', 'visaContratDCGIS', 'visaContratDGA',
      'signatureContratDG', 'notificationContratTitulaireSC', 'delaiDelivranceOS'
    ];

    numericFields.forEach(field => {
      const value = formValues[field];
      // Convertir en nombre et ajouter si c'est un nombre valide
      const numValue = parseInt(value, 10);
      if (!isNaN(numValue)) {
        sum += numValue;
      }
    });
    this.totalDelais = sum;
  }

  loadTypeModePassation(): void {
    this.typeModePassationService.getAllByAppId(this.AppService.getAppId()!).subscribe({
      next: (response: any) => {
        this.typeModePassations = response.data;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des types de modes de passation :', error);
      }
    });
  }
}
